"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var TopBarWrapper = __importStar(require("./M_TopBarWrapper"));
var ConsoleButtonCombo = __importStar(require("./M_ConsoleButtonCombo"));
var Component = function (props) {
    return (Preact.h(TopBarWrapper.Component, { colorVariant: "light", sx: { position: 'static', borderBottom: '1px solid #E0E0E0' } },
        Preact.h(Box_1.default, null,
            Preact.h("img", { src: props.logoUrl, alt: "console logo" })),
        Preact.h(ConsoleButtonCombo.Component, { secondaryText: props.secondaryButtonText, secondaryIcon: props.secondaryButtonIcon, primaryText: props.primaryButtonText, primaryAction: props.primaryAction, primaryIcon: props.primaryButtonIcon, refreshButtonCopy: props.refreshButtonCopy, refreshAction: props.refreshButtonAction })));
};
exports.Component = Component;
